// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import $ from 'jquery'; 
import moment from 'moment';
//import { Sortable } from '@shopify/draggable';
//import Draggable, {DraggableCore} from 'react-draggable'; // Both at the same time
import Loading from './Loading';
import Select from 'react-select';
import { fetchMenu, menuOrganized, capitalizeFLetter, fetchBrands, ajaxPerso, socketPerso, fetchMapping, findWherePosted } from '../../fnc'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleDown } from '@fortawesome/free-solid-svg-icons'

const refConst = require("../../constants.js").v

var initialState = {
	// itemReadyForStoreSelected: {storeFrom: null, storeTo: null, items: []},
	storeFrom: null,
	masterVendorSelected: null,
	masterCollectionSelected: null,
	storeTo: null,
	itemsValid: [],
	items: [],
	categoriesStoreTo: [],
	brandsStoreTo: [],
	itemsCreated: {}, // {sku: {handle: '', id: ''}}
	submited: false,
	_isMounted: false
}

export default function EbayReWordingInfo(props){

	const [masterVendorSelected, setMasterVendorSelected] = useState(initialState.masterVendorSelected);
	const [masterCollectionSelected, setMasterCollectionSelected] = useState(initialState.masterCollectionSelected);
	const [submited, setSubmited] = useState(initialState.submited);
	const [itemsCreated, setItemsCreated] = useState(Object.assign({}, initialState.itemsCreated));
	const [brandsStoreTo, setBrandsStoreTo] = useState(initialState.brandsStoreTo);
	const [storeFrom, setStoreFrom] = useState(initialState.storeFrom);
	const [storeTo, setStoreTo] = useState(initialState.storeTo);
	const [itemsValid, setItemsValid] = useState(initialState.itemsValid.slice(0));
	const [items, setItems] = useState(initialState.items.slice(0));
	const [categoriesStoreTo, setCategoriesStoreTo] = useState(initialState.categoriesStoreTo);
	const [version, setVersion] = useState("0.9.2");
	const [mapping, setMapping] = useState(null);

	useEffect(() => {
		initialState._isMounted = true;

		return () => initialState._isMounted = false
	}, [])

	useEffect(() => {		
		if(props.shop && itemsValid.length > 0)
			getItems(props.shop, itemsValid);
	}, [itemsValid])

	useEffect(() => {
		specialInit();
		modaleCreateItem(true);
	}, [categoriesStoreTo, brandsStoreTo, storeFrom, storeTo, itemsValid, items, submited, itemsCreated, masterVendorSelected, masterCollectionSelected])

	useEffect(() => {
		if(storeTo){
			fetchMenu( {
				"shop": storeTo
			}, () => {

			}, (r) => {
				if(!initialState._isMounted)	return false

				if(r.success){
					console.log("Fetched Categories for " + storeTo, r);
					let results = r.data
					let menu = menuOrganized(results)
		
					setCategoriesStoreTo(menu)
				}
			});

			fetchBrands( storeTo, {}, () => {
				props.loading(true);
			}, (r) => {
				if(!initialState._isMounted)	return false
				props.loading(false);
				if(r.success){
					console.log("Fetched brands for " + storeTo, r);
					let results = r.data
					setBrandsStoreTo(results)
				}
			});
		}
	}, [storeTo])

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				let fncName = capitalizeFLetter(key)
				if("_isMounted" != fncName)
					console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}
	
	let trigger = () => {

		let itemsSelected = props.itemsSelected
		if(itemsSelected.length === 0)
			return false

		findWherePosted({
			"idList": itemsSelected.join(',')
		}, (r) => {
			if(!initialState._isMounted)	return false

			console.info('Fetched presence:', r);
			if(r.success){

				let listMarketAv = getStoreWhereNeeded(r.data || [])
				
				if(listMarketAv && listMarketAv[props.shop]){
					let idItemsInStore = listMarketAv[props.shop]
					setItemsValid(idItemsInStore)
				}
			}
		})

		modaleCreateItem(false);
	}

	let modaleCreateItem = (refresh) => {
		props.modal({
			show: refresh? false : true,
			title: <span>Re-word eBay data for a better ranking<h6 className="text-secondary d-inline ml-3" style={{fontSize: "12px", textShadow: "0px 0px 4px #FFF"}}>v{version}</h6></span>,
			options: {
				width: "modal-xl"
			},
			html: (popup) => {
				console.info('Item ready for that store', items);
				
				return items === null? <Loading loading={true} centered={true}/> : <div>
					<p className="h5 mb-2">Item compatible for the selected marketplace: {itemsValid.length}</p>
					<p>This process will create a task, you will be notified by email and on the site when the task is done.</p>
					<div>
						<table className="table">
							<thead>
								<tr>
									<th scope="col" className="bg-info text-white">Id</th>
									<th scope="col" className="bg-info text-white">Brand</th>
									<th scope="col" className="bg-info text-white">SKU</th>
									<th scope="col" className="bg-info text-white">Title</th>
									<th scope="col" className="bg-info text-white">Category</th>
									{/* {submited? <th scope="col" className="bg-primary text-white">Status</th> : null} */}
								</tr>
							</thead>
							{
								items.length > 0?
									<tbody>
										<tr>
											<td colSpan={5}></td>
										</tr>
										{
											items.map((o, ii) => {
												let brandObj = brandsStoreTo.find(b => {
													if(b.name == o.vendor)	return	b
												})

												o.prefix = brandObj? brandObj.prefix : null; // brandObj && brandObj.prefix? o.sku_on_ebay.indexOf(brandObj.prefix) !== -1? o.sku_on_ebay.substr(brandObj.prefix.length) : o.sku_on_ebay : o.sku_on_ebay
												return	<tr key={`${o.id}_itemCreate`}>
													<th scope="row">{o.id}</th>
													<td>{o.brand}</td>
													<td>{o.sku_on_ebay}</td>
													<td className="w-25 overflow-auto"><div style={{height: "30px"}}><a href={o.view_item_url_natural} target="_blank" rel="noopener noreferrer">{o.title}</a></div></td>
													<td>{o.category_name}</td>
												</tr>
											})
										}
									</tbody>
									: null
							}
						</table>
					</div>
				</div>
			}
			, exit: (popup, close) => {
				close()
				setSubmited(false)
			}
			, ok: !submited? {
				title: "Create Task",
				fnc: (popup, close) => {
					// props.loading(true)
					setSubmited(true)

					reqCreatItems(props.shop, items, (r) => {
						if(!initialState._isMounted)	return false
						props.loading(false)
					})
				}
			} : false, return: {
				title: "Return",
				fnc: (popup, close) => {
					setSubmited(false)
					resetPage()
					close()
				}
			}
		});
	}

	let specialInit = () => {
		/**
		 * This fnc has for goal to do some loading depending which store was selected.
		 */
		if(!storeFrom || !storeTo)	return;

		if(storeFrom === refConst.id_store_hausfTools && storeTo === refConst.id_store_eio){
			fetchMapping( "category_haus_to_eio", (res) => {
				console.info(`Fetched fetchMapping for category_haus_to_eio`, res);
				if(res.success){
					setMapping(res.data[0].data);
				}
			})
		}
	}

	let reqCreatItems = (storeId, itemList, callbackPresence) => {
		if(!storeId || !itemList)
			throw("Please indicate a storeId / itemList.");
		else{
			let ctnItem = itemList.length,
				i = 0;

			console.info('ctnItem', itemList);

			/* ajaxPerso({
				"api": "ebay",
				"trigger": "rewordItem",
				"shop": storeId,
				"idItemList": itemList.map(o => o.id_item).join(','),
				"uid": props.getUser().uid
			}, (res) => {
				console.info("RES_SSDASDASDASD", res);
			})
			return; */

			socketPerso("task", {
				url: refConst.urlServer,
				// token: refConst.tokenEio,
				internalReq: {
					"api": "ebay",
					"trigger": "rewordItem",
					"shop": storeId,
					"idItemList": itemList.map(o => o.id_item).join(','),
					"uid": props.getUser().uid
				},
				task: {
					op: "update",
					type: "AI_work",
					store: storeId,
					args: {
						uid: props.getUser().uid,
						name: `Update title & Desc Wording for ${itemList.length} items`
					}
				}
			}, (passThrough) => {
				console.info("Res_socket", passThrough);
			})
			return;
			
			var intSend = setInterval(function(){
				console.info('itemList[i]', itemList[i]);
				console.info('ctnItemctnItem', ctnItem);
				if(ctnItem <= 0){
					console.info('ctnItem <= 0');
					clearInterval(intSend)
					return false;
				}else{
					console.info('Has to send socket'); // 67099

					ajaxPerso({
						"api": "ebay",
						"trigger": "rewordItem",
						"shop": storeId,
						"idItemList": itemList[i].id_item,
						"uid": props.getUser().uid
					}, (res) => {
						console.info("RES_SSDASDASDASD", res);
					})
					clearInterval(intSend)
					return;
					
					socketPerso("task", {
						url: refConst.urlServer,
						// token: refConst.tokenEio,
						internalReq: {
							"api": "ebay",
							"trigger": "rewordItem",
							"shop": storeId,
							"itemList": JSON.stringify([itemList[i]]),
							"pos": i,
							"uid": props.getUser().uid
						},
						task: {
							op: "insert",
							type: "eBay_product",
							store: storeId,
							args: {
								uid: props.getUser().uid,
								name: `Create Product for ${itemList[i].sku_on_ebay}`
							}
						}
					}, (passThrough) => {
						console.info("Res_socket", passThrough);

						items[passThrough.pos].successCreation = passThrough.success
						items[passThrough.pos].id_new_item = passThrough.id_new_item
						items[passThrough.pos].errors = passThrough.errors

						setItems(items.slice(0))
					})
					ctnItem--;
					i++;
				}

			}, Math.floor(1000)) // Shopify limit 2 requests for 1 seconde, so half second 500 Milliseconds
		}
	}

	let fetchItems = (storeId, idProductList, callbackPresence) => {
		if(!storeId || !idProductList || idProductList.length === 0)
			throw("Please indicate a list of product ID.");
		else{

			let apiName = false;
			apiName = [refConst.id_store_eBay_EIO, refConst.id_store_eBay_YWE].indexOf(storeId) !== -1? "ebay" : false

			ajaxPerso( {
				"api": apiName,
				"trigger": "getItems",
				"shop": storeId,
				"idProductListJson": JSON.stringify(idProductList),
			}, callbackPresence);
		}
	}

	let getItems = (storeId, idProductList) => {
		fetchItems(storeId, idProductList, (r) => {
			if(!initialState._isMounted)	return false

			if(r.success){
				console.info('Fetched_Ebay_Items', r);
				setItems(r.data.map(o => {
					o.shopify_collection = null
					return o
				}))
			}else{
				props.info({"error": r.error})
			}
		})
	}
	

	let getStoreWhereNeeded = (itemInStore) => {

		/**
			Return {
				idStore1: [idItemToCreate], idStore2: [idItemToCreate] ...
			}
		*/

		let listStoreAllowedToCreate = {};

		itemInStore.forEach(o => {
			props.stores.forEach(s => {
				if(o.list_id_store.length > 0){
					// not existing yet in this store
					if(o.list_id_store.indexOf(s.id) !== -1){
						if(!listStoreAllowedToCreate[s.id])
							listStoreAllowedToCreate[s.id] = []
						listStoreAllowedToCreate[s.id].push(o.id)
					}
				}else{
					if(!listStoreAllowedToCreate[s.id])
						listStoreAllowedToCreate[s.id] = []
					// listStoreAllowedToCreate[s.id].push(o.id)
				}
			})
		})

		console.info('itemInStore', itemInStore);
		console.info('listStoreAllowedToCreate', listStoreAllowedToCreate);
		return listStoreAllowedToCreate
	}

	let storeFromToNames = () => {
		if(props.stores.length === 0)	return ""
		
		let storeTo, storeFrom = null;
		storeTo = props.stores.find(o => {
			if(o.id === props.storeTo)	return o
		})
		storeFrom = props.stores.find(o => {
			if(o.id === props.storeFrom)	return o
		})

		return storeFrom.name + " -> " + storeTo.name
	}

	return (
		<div className="list-group-item list-group-item-action p-2 text-left" onClick={() => trigger()}>
			{
				props.title
			}
		</div>
	);
}